import React from "react";
import apiClient from "../../common/apiClient";
import "../card/card.scss";
import { Dialog } from "@mui/material";
import Button from "../button/Button";
import { CloseIcon } from "../../icons/svg";
import tickIcon from "../../images/tickIcon.png";
import { CloseNotification } from "../../components/notification/Notification";

const ClearOrder = ({ openClear, handleCloseClear, showClear, setShowClear, formId, handleClearBack, customMessage = null, isMulti = null }) => {
  const formID = formId;

  const handleClearShow = () => {
    PostClear();
    setShowClear(false);
  };

  const handleNavigation = () => {      
    setShowClear(false);
    handleClearBack();
    handleCloseClear();
  };

  async function PostClear() {
    CloseNotification();
    await apiClient.post(`ClearOrder/${formID}?isMulti=${isMulti}`,
      null
    );
  }

  return (
    <div className={`ClearOrder ${!showClear ? "submitWidth" : ""}`}>
      <Dialog
        onClose={handleCloseClear}
        aria-labelledby="customized-dialog-title"
        open={openClear ?? false}
        className={`ClearOrder ${!showClear ? "submitWidth" : ""}`}
      >
        {showClear ? (
          <>
            <div className="modalHeader">
              <h3 className="h3">Clear Order?</h3>
              <button onClick={handleCloseClear}>
                <CloseIcon />
              </button>
            </div>
            <div className="modalContent">
              <p>
                {customMessage === null || customMessage === "" ? 
                "Are you sure that you want clear the order process and start over from scratch?" :
                customMessage}
              </p>
              <Button
                text="Clear Order"
                type="button"
                onClick={handleClearShow}
              />
            </div>
          </>
         ) : (
          <>
            <div className="clearModal">
              <div className="modalHeader">
                <button onClick={handleCloseClear}>
                  
                </button>
                </div>
              <div className="modalContent">
                <img
                  src={tickIcon}
                  width="71px"
                  height="66px"
                  alt="tick-icon"
                />
                <h3 className="h3">Cleared</h3>
                <p>
                  Your order form will clear successfully!
                </p>
                <Button
                text="Confirm"
                type="button"
                onClick={handleNavigation}
              />
              </div>
            </div>
          </>
        )}
      </Dialog>
    </div>
  );
};

export default ClearOrder;